import { useListFetcherLazyHandler } from "./list-fetcher-lazy.hook";

const ListFetcherLazy = () => {
  useListFetcherLazyHandler();

  return null;
};

export default ListFetcherLazy;
